import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
export { signup };
var signupMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation Signup(\n    $userCredentials: UserCredentials!\n    $userProfile: UserProfile!\n    $clientId: String!\n  ) {\n    signUpUser(userCredentials: $userCredentials, userProfile: $userProfile, clientId: $clientId) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n      encryptedEmail\n      encryptedCheggId\n      uuid\n    }\n  }\n"])));
async function signup(creds, profile, client) {
  var data = await wrapQuery('signup', signupMutation, {
    userCredentials: creds,
    userProfile: profile,
    clientId: client
  });
  return data.signUpUser;
}